<template>
  <div id="app">
    <HeaderComponent></HeaderComponent>
    <router-view />
    <FooterComponent></FooterComponent>

    <div class="float-left back-to-top d-none d-lg-block" v-bind:class="{ hide: hide }" ref="backtotop" @click="moveUp">
      <img class="invert" src="@/assets/arrows.svg" />
      <p class="invert">
        Back to top
      </p>

    </div>

  </div>
</template>

  <!-- font-family: Avenir, Helvetica, Arial, sans-serif; -->
<style>
#app {
  font-family: 'Montserrat', sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
  background-color: #EDEDED;
}

html {
  overflow-y: scroll;
  background-color: #ededed;
}

nav {
  padding: 30px;
}

nav a {
  font-weight: bold;
  color: #fff;
  margin: 20px;
}

nav a.router-link-exact-active {
  color: #00a19a;
}

.light-purple {
  color: #A846FF;
}

.green {
  color: #00a19a;
}

.blue-background {
  background-color: #0C1892;
}

.bttn {
  margin-left: 10px;
  margin-right: 10px;
}

h1 {
  color: #0C1892;
  font-weight: bold;
}

.back-to-top {
  padding: 10px;
  display: block;
  z-index: 10;
  position: fixed;

  width: 120px;
  height: 100px;
  bottom: 40px;
  left: 40px;

  transition: all .3s ease-out;

}

.hide {
  bottom: -100px;
}

.back-to-top p {
  padding: 10px;
  display: block;
  z-index: -1;
  margin: 0;
  color: #C4C4C4 !important;

}

.back-to-top:hover {
  background-color: rgba(255, 255, 255, 0.1) !important;
  cursor: pointer;
}

.invert {
  mix-blend-mode: darken !important;
  color: white !important;
}

.big-margin {
  margin-left: 12%;
  margin-right: 12%;
  margin-top: 8%;
  margin-bottom: 8%;
}

.vertical-margin {

  margin-top: 8%;
  margin-bottom: 8%;
}

.outlined-button {
  background-color: transparent;
  border-style: solid;
  border-color: white;
  padding-left: 20px;
  padding-right: 20px;
  padding-top: 10px;
  padding-bottom: 10px;
  color: white;
}

.outlined-button:hover {
  background-color: rgba(255, 255, 255, 0.2);
}

.outlined-button p {
  margin: 0;
}

p {
  margin: 0;
}

.image {
  width: 100%;
  height: intrinsic;

}
</style>


<script>
import HeaderComponent from './components/HeaderComponent.vue';
import FooterComponent from './components/FooterComponent.vue';
// @ is an alias to /src
// import HelloWorld from '@/components/HelloWorld.vue'

export default {
  name: 'App',
  components: {
    HeaderComponent,
    FooterComponent
  },
  data: function () {
    return { hide: true, };
  },
  created() {
    window.addEventListener('scroll', this.handleScroll);
  },
  methods: {
    moveUp() {
      // scrollBehavior(0);
      window.scrollTo(0, 0);
    },
    handleScroll() {
      if (window.scrollY > window.innerHeight) {
        this.hide = false;
      }
      else {

        this.hide = true;
      }
    },

  },

  beforeDestroy() {
    window.removeEventListener('scroll', this.handleScroll);
  }
}
</script>